<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-25 09:38:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-03 10:31:00
-->
<template>
  <div class="box">
    <div class="search">
      <div class="left">
        <el-button
          @click="toAddManuscript"
          style="margin-right: 10px;"
          v-if="codeData.indexOf('348') != -1"
          type="primary"
          >新增报送</el-button
        >
        <div   class="batch-operation">
          <a-dropdown>
            <a-menu slot="overlay" @click="handleMenuClick">
                <a-menu-item v-if="codeData.indexOf('349') != -1"  key="1"> 批量报送</a-menu-item>
               <a-menu-item v-if="codeData.indexOf('350') != -1"  key="2"> 批量移出</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /> </a-button>
          </a-dropdown>
        </div>
      </div>
      <div class="right">
         <a-range-picker style="margin-right:12px;width:300px" showTime v-model="time" format="YYYY-MM-DD HH:mm:ss"/>
        <el-select
            clearable
            style="margin-left: 10px"
            v-model="dataType"
            placeholder="按报送方式筛选"
          >
           
            <el-option label="栏目推送" value="0"> </el-option>
            <el-option label="约稿" value="1"> </el-option>
            <el-option label="新增报送" value="2"> </el-option>
        </el-select>
       <a-input-group compact>
                <a-select
                v-model="selectName"
                style="width:100px; background: #ccc;margin-left:12px"
                >
                <a-select-option
                    @click="selectFn(item.value)"
                    :key="index"
                    v-for="(item, index) in selectArr"
                >
                    {{ item.label }}
                </a-select-option>
                </a-select>
                <a-input
                v-model="seachValue"
                placeholder="请输入搜索内容"
                style="width: 130px;margin-right:12px"
                />
            </a-input-group>
        <el-button  @click="listSearch" type="primary" 
          >查询</el-button 
        >
      </div>
    </div>
    <coententTable
      :y="height"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :customSlot="customSlot"
      :isSelectRow="isSelectRow"
      @selectedRowKeys="selectedRowKeys"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
      :rowKeys="rowKeys"
    >
     <template v-slot:titleName="scopeVal">
        <div v-if="scopeVal.scope.type == 1" @click="toPath(scopeVal.scope)" class="title-box">{{scopeVal.scope.title}}</div>
        <div style="cursor: pointer;" @click="chaKan(scopeVal.scope)" v-else>{{scopeVal.scope.title}}</div>
     </template>
      <template v-slot:type="scopeVal">
        {{scopeVal.scope.type == 1?'栏目推送':scopeVal.scope.type == 2?'约稿':'新增报送'}}
     </template>
      <template v-slot:stateRizhi="scopeVal">
         <a style="color:rgba(24, 109, 230, 1);" v-if="codeData.indexOf('23') != -1" @click="see(scopeVal.scope)"
            >查看</a
          >
      </template>
      <template v-slot:operation="scopeVal">
        <div style="display: flex">
          <div
            @click="submitted(scopeVal.scope)"
            class="btnTwo"
            style="margin-right: 14px;"
            v-if="codeData.indexOf('351') != -1"
          >
            报送
          </div>
           <div
            @click="editAdmin(scopeVal.scope)"
            class="btnTwo"
            style="margin-right: 14px;"
            v-if="codeData.indexOf('352') != -1"
          >
            编辑
          </div>
          <div
            v-if="codeData.indexOf('353') != -1"
            @click="open(scopeVal.scope)"
            class="btnThree"
          >
            删除
          </div>
        </div>
      </template>
    </coententTable>
    <el-dialog
      title="删除未报送稿件?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      :before-close="quxiao"
      top="17%"
    >
      <span>删除后，该稿件将从未报送稿件列表中被移出，若为栏目推送稿件，则不影响原始稿件，若为约稿或新增报送稿件，则原始稿件将一并被删除。</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="quxiao">取消</el-button>
        <el-button size="medium" :loading="deleteShow" type="danger" @click="deleteOne()">确认删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="确认报送？"
      :visible.sync="dialogVisible"
      width="450px"
      custom-class="tips-box"
      :before-close="quxiaoTwo"
      top="17%"
    >
      <span>报送后，该稿件将发送至指定组织中，待该组织管理人员采纳后，您所在组织将获得相应的加分。</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="quxiaoTwo">取消</el-button>
        <el-button @click="baosong" :loading="baosongShow" type="primary" size="medium">确认报送</el-button>
      </span>
    </el-dialog>
    <See :item="itemData" @closeTwo="closeTwo" :visible="visible"></See>
    <AddSubmission :isAdd="isAdd" :item="itemData" :type="2" @onClose="onClose" @close="close" :visible="visibleAdd"></AddSubmission>
     <Tips :item="itemData"  @onClose="onCloseTips" @close="onCloseTips" :visible="visibleAddTips"/>
  </div>
</template>

<script>
import {
  deleteById,
  selectPage,
  submittedData,
} from "./index";
import coententTable from "@/components/coentent_table.vue";
import { message } from "ant-design-vue";
import See from "@/components/more_information.vue";
import AddSubmission from './add_submission.vue';
import Tips from './tips.vue';
export default {
  data() {
    return {
      selectName: "标题",
      visibleAdd:false,
      visible:false,
      visibleAddTips:false,
      selectValue: 1,
      seachValue:'',
      isMore:false,
      isMoreTwo:false,
      selectArr:[
                {
                    'label':'标题',
                    'value':1,
                },
                {
                    'label':'创作人员',
                    'value':2,
                }
            ],
      height: 0,
      time: [],
      columns: [
        {
          title: "标题",
          dataIndex: "title",
          ellipsis: true,
          customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        scopedSlots: { customRender: "titleName" },
      },
        {
          title: "报送方式",
          dataIndex: "type",
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "创作人员",
          dataIndex: "createName",
          width: 120,
        },
         {
          title: "创作时间",
          dataIndex: "createTime",
          width: 200,
        },
        {
          title: "日志",
          dataIndex: "stateRizhi",
          scopedSlots: { customRender: "stateRizhi" },
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 250,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      columnId: "",
      customSlot: [
        {
          name: "titleName",
          customRender: "titleName",
        },
         {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
        {
          name: "type",
          customRender: "type",
        },
      ],
      rowKeys: [],
      dataType:'',
      loading: false,
      isSelectRow: true,
      loading: false,
      dialogVisibleTwo: false,
      dialogVisibleColum: false,
      codeData: [],
      dialogVisible:false,
      visibleAdd:false,
      itemData:{},
      isAdd:true,
      deleteShow:false,
      baosongShow:false,
    };
  },
  components: {
    coententTable,
    See,
    AddSubmission,
    submittedData,
    Tips
  },
  mounted() {
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    onClose(){
      this.visibleAdd = false;
      this.getList()
    },
    onCloseTips(){
       this.visibleAddTips = false;
    },
    close(){
       this.visibleAdd = false;
    },
    chaKan(item){
      this.itemData = item;
      this.visibleAddTips = true;
    },
    closeTwo(){
      this.visible = false;
    },
    submitted(item){
      this.dialogVisible = true;
      this.itemData = item;
      this.isMore = true;
    },
     farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
     handleMenuClick(e) {
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return false;
      }
      if (e.key == 1) {
        this.dialogVisible = true;
        this.isMore = false;
      }else{
        this.dialogVisibleTwo = true;
        this.isMoreTwo = false;
      }
    },
    toAddManuscript() {
       this.visibleAdd = true;
        this.isAdd = true;
    },
    toPath(item){
        window.open(item.viewUrl)
    },
    see(item) {
       this.visible = true;
       this.itemData = item;
    },
    selectFn(value) {
      this.selectValue = value;
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    editAdmin(item) {
       if(item.type == 1){
           let routeData =  this.$router.resolve({
            path: "/index/content/manuscripts_edit",
            query: {
              id:item.manuscriptId,
              title: "编辑稿件",
              islast: true,
            },
          });
          window.open(routeData.href, '_blank');
       }else{
          this.itemData = item;
          this.visibleAdd = true;
          this.isAdd = false;
       }
    },
    getList() {
      this.loading = true;
      let startTime = '';
      let endTime = '';
      if(this.time.length > 0){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      selectPage({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        dataType:this.dataType,
        type: this.selectValue,
        startTime,
        endTime,
        value:this.seachValue,
        organizationId: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        if(this.pagination.total > 0){
          this.height = document.documentElement.clientHeight - 400;
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 400;
            })();
          };
        }
        if (this.pagination.current != 1 && this.dataSource.length == 0) {
          this.pagination.current--;
          this.getList();
        }
        this.loading = false;
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    selectedRowKeys(keys) {
      this.rowKeys = keys;
    },
    open(item) {
      this.dialogVisibleTwo = true;
      this.itemData = item;
      this.isMoreTwo = true;
    },
    quxiao(){
      this.dialogVisibleTwo = false;
    },
    baosong(){
      this.baosongShow = true;
      let array = [];
      if(this.isMore){
        array = [this.itemData.id]
      }else{
         array = this.rowKeys;
      }
      submittedData({
        idList:array,
      }).then((res)=>{
          if(res.code == 0){
            this.baosongShow = false;
            this.dialogVisible = false;
            this.rowKeys = [];
            this.getList();
          }
      })
    },
    quxiaoTwo(){
      this.dialogVisible = false;
    },
    deleteOne() {
      this.deleteShow = true;
      let array = [];
      if(this.isMoreTwo){
        array = [this.itemData.id]
      }else{
         array = this.rowKeys;
      }
      deleteById({
        idList: array,
      }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.deleteShow = false;
          this.rowKeys = [];
          this.getList();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  .search {
    padding: 24px;
    display: flex;
    width: 100%;
    padding-bottom: 0px;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
    }
    .icon-st-doc-edit:before {
      color: #fff;
      margin-right: 5px;
      font-size: 16px;
    }
    .batch-operation {
      margin-right: 12px;
      /deep/ .ant-btn,
      .ant-dropdown-trigger {
        height: 40px;
        background: #ecf5ff;
        color: #18abff;
        border-color: #c9e3ff;
        text-align: center;
      }
    }
    .right {
      display: flex;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
.column-box {
  /deep/ .ant-table-body {
    max-height: 450px;
    overflow: auto;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 10px;
  }
}
.column-style {
  display: flex;
  cursor: pointer;
}
.item-one {
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-bottom: 5px;
  line-height: 20px;
}
.column-number {
  padding: 0 10px;
  height: 20px;
  border-radius: 3px;
  background-color: rgba(236, 245, 255, 1);
  color: rgba(64, 158, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(217, 236, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
}
.column-numberTwo {
  width: 56px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.footer-style {
  text-align: right;
  margin-right: 23px;
  margin-bottom: 12px;
}
.column-box-two, .column-box {
  /deep/ .table {
    margin-bottom: 24px;
    margin-left: 0;
    margin-right: 0;
  }
  /deep/
    .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #fafafa;
  }
}
.title-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 10px;
  .title-top-left {
    height: 17px;
    color: rgba(48, 49, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
  .title-top-right {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: right;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
.title-box {
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration:underline;
  cursor: pointer;
  color: rgba(24, 109, 230, 1);
  }
  /deep/ .ant-input-group{
    width: auto;
  }
</style>